import { render, staticRenderFns } from "./specific-shopify-gql.vue?vue&type=template&id=25753790&"
import script from "./specific-shopify-gql.vue?vue&type=script&lang=js&"
export * from "./specific-shopify-gql.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports